import React from 'react';
import { Col, Row } from 'antd';
import logo from '../../assets/logo.svg';
import paymentFailed from '../../assets/404-page-not-found.svg';
import LanguageDropdown from '../../components/Language-Dropdown/LanguageDropdown';

export default function InvalidSlugPage() {
  return (
    <div className="main_section h-full bg-mobile-view">
      <div className="container px-only-md-2 box-alignment">
        <div className="w-100 pt-3 mb-3" style={{ zIndex: '9992' }}>
          <Row gutter={[16, 16]}>
            <Col xs={0} md={4} style={{ padding: '0px', margin: '0px' }} />
            <Col xs={12} md={15}>
              <div className="text-md-center logo-size">
                <img src={logo} alt="logo" width={245} height={60} />
              </div>
            </Col>
            <Col xs={12} md={4} className="btn-hide-hove">
              <LanguageDropdown />
            </Col>
          </Row>
        </div>
        <div style={{ margin: 'auto', width: '500px', height: '500px' }}>
          <img
            src={paymentFailed}
            alt="paymentFailed img"
            style={{ margin: 'auto', width: '500px', maxHeight: '300px' }}
          />
        </div>
      </div>
    </div>
  );
}
